import { Component, Input, OnInit } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import {NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-new-transaction-listing',
  templateUrl: './new-transaction-listing.component.html',
  styleUrls: ['./new-transaction-listing.component.scss']
})
export class NewTransactionListingComponent implements OnInit {

  @Input() public transactionId;
  userId: any;
  transactions: any;
  private modalRef;

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.userId = this.transactionId;

    this.vip_token_transactions_subadmin(this.userId);
  }

  vip_token_transactions_subadmin(id) {
    let formData = new FormData();
    formData.append('id', id);

    this.auth.vip_token_transactions_subadmin(formData).subscribe((response: any) => {
      
      this.transactions = response.body;

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message)
      }
    });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
